import { DashboardCardConfig } from '../types/DashboardCardConfig';
import { Permission, PermissionAction, LkHomeDashboardId } from 'generated/openApi';


export const DEFAULT_CARD_CONFIGS: DashboardCardConfig[] = [
    {
        id: 'service-chart',
        name: 'Services - Chart',
        description: 'Bar chart showing service activities',
        icon: 'BarChart',
        enabled: true,
        order: 1,
        category: 'Services',
        isNew: false,
        dashboardId: LkHomeDashboardId.Service,
    },
    {
        id: 'service-table',
        name: 'Services - Table',
        description: 'Detailed service data with export',
        icon: 'TableChart',
        enabled: true,
        order: 2,
        category: 'Services',
        isNew: false,
        dashboardId: LkHomeDashboardId.Service,
    },
    {
        id: 'match-chart',
        name: 'Match Contribution - Chart',
        description: 'Pie chart of match cost breakdown',
        icon: 'PieChart',
        enabled: true,
        order: 3,
        category: 'Match',
        isNew: false,
        dashboardId: LkHomeDashboardId.Match,
    },
    {
        id: 'match-table',
        name: 'Match Contribution - Table',
        description: 'Itemized match costs with export',
        icon: 'TableChart',
        enabled: true,
        order: 4,
        category: 'Match',
        isNew: false,
        dashboardId: LkHomeDashboardId.Match,
    },
    {
        id: 'notifications',
        name: 'Notifications',
        description: 'Recent system notifications and updates',
        icon: 'Checklist',
        enabled: true,
        order: 5,
        category: 'System',
        isNew: false,
        locked: true,
    },
    {
        id: 'total-students',
        name: 'Total Students',
        description: 'View total student count by grade level',
        icon: 'School',
        enabled: false,
        order: 6,
        category: 'Students',
        isNew: false,
        requiredPermissions: [
            {
                permission: Permission.StudentEnrollment,
                action: PermissionAction.View,
            },
        ],
    },
    {
        id: 'school-enrollment',
        name: 'School Enrollments',
        description: 'Top schools ranked by student enrollment',
        icon: 'School',
        enabled: false,
        order: 7,
        category: 'Students',
        isNew: false,
        requiredPermissions: [
            {
                permission: Permission.StudentEnrollment,
                action: PermissionAction.View,
            },
        ],
    },
    {
        id: 'fafsa-chart',
        name: 'FAFSA Submission Chart',
        description: 'Visualizes FAFSA submission rates by year',
        icon: 'School',
        enabled: true,
        order: 8,
        category: 'Students',
        isNew: true,
    },
    {
        id: 'fafsa-table',
        name: 'FAFSA Submission Table',
        description: 'Displays FAFSA submission data in table format',
        icon: 'TableChart',
        enabled: true,
        order: 9,
        category: 'Students',
        isNew: true,
    },
    {
        id: 'end-reason-type-table',
        name: 'End Reason Type Table',
        description: 'View student end reasons by type in table format',
        icon: 'TableChart',
        enabled: false,
        order: 8,
        category: 'Students',
        isNew: false,
        requiredPermissions: [
            {
                permission: Permission.StudentEnrollment,
                action: PermissionAction.View,
            },
        ],
    },
    {
        id: 'end-reason-type-chart',
        name: 'End Reason Type Chart',
        description: 'Visualize student end reasons by type with stacked bar chart',
        icon: 'BarChart',
        enabled: false,
        order: 9,
        category: 'Students',
        isNew: true,
        requiredPermissions: [
            {
                permission: Permission.StudentEnrollment,
                action: PermissionAction.View,
            },
        ],
    },
];